import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const homeRoute = 'dashboard'
const authRoute = 'login'

let router = new Router({
  routes: [{
    path: '/',
    name: 'landing',
    meta: {
      requiresAuth: true,
      layout: 'dashboard'
    }
  }, {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      guest: true,
      layout: 'empty'
    }
  }, {
    path: '/dashboard',
    name: 'disaster.dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: {
      requiresAuth: true,
      layout: 'dashboard'
    }
  }, {
    path: '/live-stream',
    name: 'disaster.live-stream',
    component: () => import('../views/LiveStream.vue'),
    meta: {
      requiresAuth: true,
      layout: 'dashboard'
    }
  }, {
    path: '/map',
    name: 'disaster.map',
    component: () => import('../views/Map.vue'),
    meta: {
      requiresAuth: true,
      layout: 'dashboard'
    }
  }, {
    path: '/alert',
    name: 'disaster.alert',
    component: () => import('../views/Alert.vue'),
    meta: {
      requiresAuth: true,
      layout: 'dashboard'
    }
  }, {
    path: '/cctv',
    name: 'disaster.cctv',
    component: () => import('../views/Cctv.vue'),
    meta: {
      requiresAuth: true,
      layout: 'dashboard'
    }
  }, {
    path: '/add-site',
    name: 'disaster.add-site',
    component: () => import('../views/AddSite.vue'),
    meta: {
      requiresAuth: true,
      layout: 'dashboard'
    }
  }, {
    path: '/sites/:id',
    name: 'disaster.site',
    component: () => import('../views/Site.vue'),
    meta: {
      requiresAuth: true,
      layout: 'dashboard'
    }
  }]
})

router.beforeEach((to, from, next) => {
  const tokenIsValid = Vue.Helper.validateToken()

  if (!to.matched.some(record => record.meta.dontJumpToTop)) {
    window.scrollTo(0, 0)
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!tokenIsValid) {
      next({
        path: authRoute,
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      const user = JSON.parse(localStorage.getItem('user'))

      if (to.matched.some(record => record.meta.isAdmin)) {
        if (user.isAdmin == 1) {
          next()
        } else {
          next({
            name: homeRoute
          })
        }
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!tokenIsValid) {
      next()
    } else {
      next({
        name: homeRoute
      })
    }
  } else {
    next()
  }
})

export default router